import { useState } from 'react';
import { useDebounce } from 'react-use';

interface Input<T> {
  value: T;
  ms?: number;
}

interface Output<T> {
  value: T;
  cancel: () => void;
}

/**
 * Wrapper hooks for useDebounce
 */
export function useDebouncedValue<T>({ value, ms = 500 }: Input<T>): Output<T> {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  const [, cancel] = useDebounce(
    () => {
      setDebouncedValue(value);
    },
    ms,
    [value]
  );

  return {
    value: debouncedValue,
    cancel, // Expose cancel for additional control if needed
  };
}
